export { sendFBEvent } from './fpixel'
export { default as sendGAEvent } from './google-analytics'
export { FacebookPixel } from './pixel-analytics'
